"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const animationName = 'loaderTraceLogo';
const animationDuration = 1500;
exports.default = theme => ({
    root: {
        width: 29,
        height: 29,
        position: 'relative',
        color: theme.indigo3,
        flexShrink: 0,
        '& > em': {
            position: 'absolute',
            top: 0,
            width: 7,
            backgroundColor: 'currentColor',
            animationName: animationName,
            animationDirection: 'alternate',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'ease-in-out',
            transformOrigin: '50% 0',
            transform: 'scaleY(1)',
            borderRadius: 1
        },
        '& > em:first-child': {
            left: 0,
            height: 14,
            animationDuration: `${animationDuration}ms`
        },
        '& > em:nth-child(2)': {
            left: 11,
            height: 25,
            animationDelay: `${animationDuration * 0.1}ms`,
            animationDuration: `${animationDuration * 0.9}ms`
        },
        '& > em:last-child': {
            right: 0,
            height: 18,
            animationDelay: `${animationDuration * 0.3}ms`,
            animationDuration: `${animationDuration * 0.7}ms`
        }
    },
    rootLight: {
        color: theme.grey7
    },
    [`@keyframes ${animationName}`]: {
        from: { transform: 'scaleY(1)' },
        to: { transform: 'scaleY(0.05)' }
    }
});
//# sourceMappingURL=loader.traceLogo.style.js.map